import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
import store from './redux/store';
import applyPolyfills from './utils/polyfills';

import './assets/styles/fonts.css';
import './assets/styles/global.scss';

const renderApp = () => {
  const container = document.getElementById('root');
  const root = createRoot(container);
  applyPolyfills();
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
  );
};

if (process.env.NODE_ENV !== 'production' && module.hot) {
  module.hot.accept('./App', renderApp);
}

renderApp();
